// extracted by mini-css-extract-plugin
export default {"header":"ActivityHeader_header__uiqtS","title":"ActivityHeader_title__gFjxp","closeButton":"ActivityHeader_closeButton__EEIXQ"};